import React from 'react';

const CardAction = ({ data }) => {
  const handleClick = () => {
    window.location.href = data.path; // Redirect to the specified path
  };

  return (
    <div onClick={handleClick} className='card-action'>
      <img src={data.img} alt={data.title} />
      <h5>{data.title}</h5>
    </div>
  );
};

export default CardAction;
